import { Controller } from "../../ts/controller";
import { Logger } from "../../ts/utils/logger";

export class AppbarController extends Controller {
    sideNavToggleButtonVisible: boolean = false;

    constructor() {
        super({
            logLabel: "AppbarController",
        });
    }

    public initialize(): void {
        this.bindClick({
            elementId: "side-nav-toggle-button",
            handler: this._toggleSideNavVisible.bind(this),
        });
        Logger.info(this.logLabel, "Initialized");
    }

    private _toggleSideNavVisible(): void {
        window.sideNavController.toggleVisible();
    }

    public blockAppbarPrint(): void {
        const appbarMain = this.getElementByIdOrWarn('appbar-main');
        const appbarSub = this.getElementByIdOrWarn('appbar-sub');
        if (appbarMain && appbarSub) {
            appbarMain.classList.add('print-force-hide');
            appbarSub.classList.add('print-force-hide');
        }
    }

    public allowAppbarPrint(): void {
        const appbarMain = this.getElementByIdOrWarn('appbar-main');
        const appbarSub = this.getElementByIdOrWarn('appbar-sub');
        if (appbarMain && appbarSub) {
            appbarMain.classList.remove('print-force-hide');
            appbarSub.classList.remove('print-force-hide');
        }
    }
}
